import { CountryGetCollectionByTrialCode, CountryCollectionResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<CountryCollectionResponse, CountryCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<CountryCollectionResponse, CountryCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useCountries = (trialCode: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new CountryGetCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);
    
    return useGet(request, { getData, getError}, configuration);
};

export default useCountries;